import { Input } from "antd";
import { useThrottle } from "../../../../uikit/hooks/useThrottle";
import { FocusEventHandler, KeyboardEventHandler, Ref, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import func from "@uikit/func";
import style from "./JsonNode.module.scss";
import cls from "classnames";
import { NO_WHEEL } from "../constants";
import classNames from "classnames";
import { useStartNode } from "../../../../custom-hooks/useNodePreview";

type JsonProps = {
  id: string;
  inputRef: Ref<HTMLElement>;
  textAreaValue: Array<any>;
  checkNodeArr: Array<any>;
  placeholder: string;
  isLongPress: boolean;
  isResized: boolean;
  onTextAreaBlur: (e: any, value?: any) => void;
  onTextAreaFocus: FocusEventHandler<HTMLTextAreaElement>;
  onTextAreaEnter: KeyboardEventHandler<HTMLTextAreaElement>;
  setTextAreaValueWithParam: Function;
  guideNodeEditable: boolean;
  isTargetNode: boolean;
  showFeedback: boolean;
  showStopGenerateBtn: boolean;
  parentNodeId: string;
  noWheelClassName: string;
  enableFeedback?: boolean;
  isStaticApp: boolean;
  resizeEventParams: { width: number; height: number };
};

export const Json: React.FC<JsonProps> = props => {
  const inputBoxRef = useRef<null | HTMLDivElement>(null);
  const value = props.textAreaValue[0].results[0].content || "";

  const imagicaStudioTutorial = useSelector((state: any) => state.fot.imagicaStudioTutorial);
  const disableAddPreview = useSelector((state: any) => state.fot.disableAddPreview);
  const { isStartNode, isStartNodeAdded } = useStartNode(props.id);

  useThrottle(
    () => {
      if (value.length > 260 && inputBoxRef.current && props.showStopGenerateBtn === true) {
        // 滚动到底部
        const distance = inputBoxRef.current.scrollHeight - inputBoxRef.current.clientHeight;
        inputBoxRef.current.scrollTop = distance;
      }
    },
    100,
    [value, props.showStopGenerateBtn]
  );

  useEffect(() => {
    if (props.showStopGenerateBtn === false) {
      setTimeout(() => {
        // 滚动到顶部
        if (inputBoxRef.current) {
          inputBoxRef.current.scrollTop = 0;
        }
      }, 200);
    }
  }, [props.showStopGenerateBtn]);

  const textNodeClassName = cls(
    style["custom-node"],
    style["design-text"],

    (props.isLongPress || (props.checkNodeArr && props.checkNodeArr.includes(props.id))) && `nopan ${NO_WHEEL}`,
    style["guide-textnode-disable"],
    props.enableFeedback && style["target"],
    !disableAddPreview && isStartNode && !isStartNodeAdded && !props?.isStaticApp ? style.reservedButtonHeight : ""
  );

  let reSizeStyle: { width?: number; height?: number | string } = { width: undefined, height: undefined };
  if (props.resizeEventParams) {
    reSizeStyle.width = props.resizeEventParams.width;
    if (props.resizeEventParams.height) {
      reSizeStyle.height = props.resizeEventParams.height - 70;
    } else {
      reSizeStyle.height = "auto";
    }
  }

  return (
    <div className={textNodeClassName} ref={inputBoxRef} style={reSizeStyle}>
      <div className={style["text-content"]}>
        {/* 双击选中Input */}
        <div
          className={`${style["input-mask"]} ${props.isLongPress ? style["hidden-mask"] : ""} ${
            !disableAddPreview ? style["previewing"] : ""
          }`}
        >
          {!props.isLongPress && (func.isEmpty(value) || typeof value === "string") ? (
            <p className={`${style["alternate-text"]} ${func.isEmpty(value) ? style["place-color"] : ""}`}>
              {(typeof value === "string" && value) || props.placeholder || "Enter Input"}
            </p>
          ) : null}
        </div>

        <div
          className={classNames(style["text-textArea"], {
            nodrag: props.isLongPress,
            [style["show-text-textArea"]]: props.isLongPress,
            [style["max-textarea-height"]]: !props.isResized,
          })}
        >
          <Input.TextArea
            className={`${style.textarea} ${!props.isLongPress ? "hidden-input" : ""}`}
            readOnly={imagicaStudioTutorial.showGuide && !props.guideNodeEditable}
            value={props.textAreaValue[0].results[0].content || ""}
            ref={props.inputRef}
            onPressEnter={props.onTextAreaEnter}
            onChange={e =>
              props.setTextAreaValueWithParam({
                content: e.target.value,
              })
            }
            onBlur={e => props.onTextAreaBlur(e)}
            onFocus={props.onTextAreaFocus}
            placeholder={props.placeholder || "Enter Input"}
            autoSize={{ minRows: 4 }}
          />
        </div>
      </div>
    </div>
  );
};
